import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IBurstSetting,
  IBurstSettingRow,
} from '../../../../view/settings/api-automation-settings/burst-settings/burst-settings.model';

@Injectable({
  providedIn: 'root',
})
export class BurstSettingService {
  private readonly BURST_SETTINGS_URL = `${this.baseUrl}/api-automation/burst-settings`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IBurstSetting>> {
    return this.http.get<GetManyResponseInterface<IBurstSetting>>(this.BURST_SETTINGS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IBurstSetting>> {
    return this.http.get<BaseOneResponseInterface<IBurstSetting>>(`${this.BURST_SETTINGS_URL}/${recordId}`, { params });
  }

  public addOne(record: IBurstSettingRow): Observable<BaseOneResponseInterface<IBurstSetting>> {
    return this.http.post<BaseOneResponseInterface<IBurstSetting>>(this.BURST_SETTINGS_URL, record);
  }

  public editOne(recordId: number, record: IBurstSettingRow): Observable<BaseOneResponseInterface<IBurstSetting>> {
    return this.http.patch<BaseOneResponseInterface<IBurstSetting>>(`${this.BURST_SETTINGS_URL}/${recordId}`, record);
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          burstSettings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.BURST_SETTINGS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.BURST_SETTINGS_URL}/${recordIds[0]}`);
  }
}
